<template>
  <div class="padd">
    <p class="notice reservation_service_notice red-text" @click="showHideTips" v-if="tipsType === 'buyTicket'">
      <i class="iconfont icon-gantanhao"></i>
      <span>机场大巴购票规则</span>
    </p>
    <p class="notice reservation_service_notice red-text" @click="showHideTips" v-else-if="tipsType === 'pickupTips'">
      <i class="iconfont icon-gantanhao"></i>
      <span>机场大巴购票规则</span>
    </p>
    <span class="notice reservation_service_notice red-text" @click="showHideTips" v-else-if="tipsType === 'appointTips'">
      <i class="iconfont icon-gantanhao"></i>
      <span>旗妙出行约车须知</span>
    </span>


    <transition :name="transitionName" mode="out-in">

      <article class="mask_wrap" v-show="isShow" @click.self="showHideTips">
        <!-- buyTicket Tips Start-->
        <transition name="scale_up" mode="out-in">
          <!-- pickupTips Tips Start-->
          <section class="mask_container_wrap" v-if="tipsType==='buyTicket'">
            <div class="mask_article_wrap">
              <h3 class="article_title red_color">机场快线购票须知</h3>
              <p class="primary_color p_title">一、购票</p>
              <p class="text_retract">
                持一张成人票的旅客可免费携带一名1.2米以下的儿童乘车，但不提供座位。交通法规定：班车在载客数已满的情况下，免票儿童不得超过3名，以先到先得为标准，超出部分须补儿童票价上车（占座），身高1.2-1.5米儿童须购买儿童优惠票。超过1.5米儿童须购买全价票。
              </p>
              <p class="text_retract">
                1.
                微信购票时，请确认您输入的个人资料和联系方式正确无误，并保持电话畅通，以便我们能及时跟您联系。因您所留的资料不详或者不正确，或您所提供的电话号码长时间处于无人接听、忙音等状况而使我们不能及时联系到您，由此造成的损失，均由旅客本人负责。
              </p>
              <p class="text_retract">2. 微信购票须至少在班车发车前30分钟购买。</p>
              <p class="text_retract">3. 乘车证件包括但不限于身份证、护照、港澳通行证等。</p>

              <p class="primary_color p_title">二、支付</p>
              <p class="text_retract">1. 微信上购票目前只支持微信支付平台。</p>
              <p class="text_retract">2. 购票时，您必须在订单提交后的10分钟内完成支付操作，逾时系统将自动取消订单，需重新操作。</p>
              <p class="text_retract">
                3.
                请勿重复支付订单。当您完成支付后，请查询订单状态，如系统发生订单状态错误等异常情况，请及时联系客服0760-88880777进行确认，在没有最终确定购票结果前，请勿重新支付订单，以免给您造成不必要的损失。
              </p>
              <p class="text_retract">4. 微信购票费用包含5元的服务费、微信平台开发费用及网络维护费。</p>

              <p class="primary_color p_title">三、取票</p>
              <p class="text_retract">购票成功后，请您在票面发车时间15分钟前到达中山候机楼取票窗口凭有效证件（包括但不限于身份证、护照、港澳通行证等）和订单二维码领取车票。</p>

              <p class="primary_color p_title">四、退票</p>

              <div class="table">
                <ul class="tr bg_th_orderinfo">
                  <li class="th"></li>
                  <li class="th">普通旅客</li>
                  <li class="th">会员</li>
                </ul>
                <ul class="tr">
                  <li class="td">发车前2小时以(外)办理退票</li>
                  <li class="td">按票面额10%计收退票费</li>
                  <li class="td">免费</li>
                </ul>
                <ul class="tr">
                  <li class="td">发车前2小时以(内)办理退票</li>
                  <li class="td">按票面额20%计收退票费</li>
                  <li class="td">免费</li>
                </ul>
                <ul class="tr">
                  <li class="td">发车后</li>
                  <li class="td">不作退票</li>
                  <li class="td">按票面额30%计收退票费</li>
                </ul>
              </div>
              <p class="text_retract">由于承运人责任造成班车晚点、脱班等延迟运输的，旅客可根据需要改乘其他班次或退票，免收退改费,会员详情请咨询0760-88880777。</p>

              <p class="primary_color p_title">五、注意事项</p>
              <p class="text_retract">
                1.在购票时，请旅客务必确保购票信息的准确无误，由于旅客自身原因（包括但不限于发车班次、发车时间、联系人等信息填写错误）而导致购票错误并给旅客造成的一切损失，均由旅客个人负责。
              </p>
              <p class="text_retract">
                2.在线支付时，请旅客务必保管好您个人银行账号、密码、回单等资料。因旅客未保管好自己的账号和密码及回单等个人资料的原因，造成对旅客、候机楼或任何第三方的损害，旅客本人将负全部责任。
              </p>
            </div>
          </section>
          <!-- appointTips Tips Start-->
          <section class="mask_container_wrap" v-if="tipsType==='appointTips'">
            <div class="mask_article_wrap">
              <h3 class="article_title red_color">机场快线购票须知</h3>
              <p class="primary_color p_title">一、购票</p>
              <p class="text_retract">
                持一张成人票的旅客可免费携带一名1.2米以下的儿童乘车，但不提供座位。交通法规定：班车在载客数已满的情况下，免票儿童不得超过3名，以先到先得为标准，超出部分须补儿童票价上车（占座），身高1.2-1.5米儿童须购买儿童优惠票。超过1.5米儿童须购买全价票。
              </p>
              <p class="text_retract">
                1.
                微信购票时，请确认您输入的个人资料和联系方式正确无误，并保持电话畅通，以便我们能及时跟您联系。因您所留的资料不详或者不正确，或您所提供的电话号码长时间处于无人接听、忙音等状况而使我们不能及时联系到您，由此造成的损失，均由旅客本人负责。
              </p>
              <p class="text_retract">2. 微信购票须至少在班车发车前30分钟购买。</p>
              <p class="text_retract">3. 乘车证件包括但不限于身份证、护照、港澳通行证等。</p>

              <p class="primary_color p_title">二、支付</p>
              <p class="text_retract">1. 微信上购票目前只支持微信支付平台。</p>
              <p class="text_retract">2. 购票时，您必须在订单提交后的10分钟内完成支付操作，逾时系统将自动取消订单，需重新操作。</p>
              <p class="text_retract">
                3.
                请勿重复支付订单。当您完成支付后，请查询订单状态，如系统发生订单状态错误等异常情况，请及时联系客服0760-88880777进行确认，在没有最终确定购票结果前，请勿重新支付订单，以免给您造成不必要的损失。
              </p>
              <p class="text_retract">4. 微信购票费用包含5元的服务费、微信平台开发费用及网络维护费。</p>

              <p class="primary_color p_title">三、取票</p>
              <p class="text_retract">购票成功后，请您在票面发车时间15分钟前到达中山候机楼取票窗口凭有效证件（包括但不限于身份证、护照、港澳通行证等）和订单二维码领取车票。</p>

              <p class="primary_color p_title">四、退票</p>

              <div class="table">
                <ul class="tr bg_th_orderinfo">
                  <li class="th"></li>
                  <li class="th">普通旅客</li>
                  <li class="th">会员</li>
                </ul>
                <ul class="tr">
                  <li class="td">发车前2小时以(外)办理退票</li>
                  <li class="td">按票面额10%计收退票费</li>
                  <li class="td">免费</li>
                </ul>
                <ul class="tr">
                  <li class="td">发车前2小时以(内)办理退票</li>
                  <li class="td">按票面额20%计收退票费</li>
                  <li class="td">免费</li>
                </ul>
                <ul class="tr">
                  <li class="td">发车后</li>
                  <li class="td">不作退票</li>
                  <li class="td">按票面额30%计收退票费</li>
                </ul>
              </div>
              <p class="text_retract">由于承运人责任造成班车晚点、脱班等延迟运输的，旅客可根据需要改乘其他班次或退票，免收退改费,会员详情请咨询0760-88880777。</p>

              <p class="primary_color p_title">五、注意事项</p>
              <p class="text_retract">
                1.在购票时，请旅客务必确保购票信息的准确无误，由于旅客自身原因（包括但不限于发车班次、发车时间、联系人等信息填写错误）而导致购票错误并给旅客造成的一切损失，均由旅客个人负责。
              </p>
              <p class="text_retract">
                2.在线支付时，请旅客务必保管好您个人银行账号、密码、回单等资料。因旅客未保管好自己的账号和密码及回单等个人资料的原因，造成对旅客、候机楼或任何第三方的损害，旅客本人将负全部责任。
              </p>
            </div>
          </section>

        </transition>

      </article>

    </transition>

  </div>
</template>

<script>
export default {
  name: 'DescriptionMask',
  data() {
    return {
      isShow: false,
      transitionName:'tanchu'
    };
  },
  props: {
    tipsType: {
      type: String,
    }
  },
  methods: {
    showHideTips() {
      this.isShow = !this.isShow;
    }
  }
};
</script>

<style scoped lang="less">
  @import '../../style/public';
  .padd{
    .blockPadding(0);
  }
</style>



// WEBPACK FOOTER //
// src/components/child-components/DescriptionMask.vue